(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

import React from 'react';
import styled from 'styled-components';
import { COLOR } from "../../constants/style";
import { AccountCircle, Add, AnnouncementOutlined, ArrowDropUp, ArrowDropDown, KeyboardArrowLeft, KeyboardArrowRight, ArrowUpward, ArrowDownward, AttachFile, Cancel, Check, CheckCircleOutline, Clear, Close, Cloud, CloudDownload, CloudUpload, Contacts, DateRange, Description, Delete, Edit, Email, Error as ErrorIcon, ErrorOutline, Event, ExpandLess, ExpandMore, Folder, ForwardOutlined, GetApp, Group, Help, HourglassEmpty, Http, Info, InfoOutlined, InsertDriveFile, InsertDriveFileOutlined, Language, Launch, Link, Lock, Menu, Person, PersonAdd, PersonOutline, PhoneIphone, Refresh, Remove, RemoveCircle, RemoveCircleOutline, ReportProblemOutlined, RestorePage, Search, Send, SendOutlined, CancelScheduleSendOutlined, Save, Settings, Share, Sms, ThumbDownOutlined, ThumbUpOutlined, Visibility, VisibilityOff, Warning, WatchLaterOutlined } from '@material-ui/icons'; // TODO: May want to size icons in a different way

var StyledIcon = styled('div').withConfig({
  displayName: "Icon__StyledIcon",
  componentId: "sc-19atuh5-0"
})(["display:", ";align-items:center;justify-content:center;& svg{", " ", "}"], function (props) {
  return props.inline ? 'inline-flex' : 'flex';
}, function (props) {
  return props.color ? "color: ".concat(props.color, ";") : '';
}, function (props) {
  switch (props.size) {
    case 'xxs':
      return 'height: 12px; width: 12px';

    case 'xs':
      return 'height: 16px; width: 16px';

    case 'sm':
      return 'height: 20px; width: 20px';

    case 'md':
      return 'height: 24px; width: 24px';

    case 'lg':
      return 'height: 32px; width: 32px';

    case 'xl':
      return 'height: 40px; width: 40px';

    case 'xxl':
      return 'height: 64px; width: 64px';

    case 'xxxl':
      return 'height: 84px; width: 84px';

    default:
      return;
  }
});

var _default = function _default(props) {
  var color = props.color,
      name = props.name;
  var iconSet = {
    attachment: AttachFile,
    ascending: ArrowDropUp,
    add: Add,
    announcementOutlined: AnnouncementOutlined,
    arrowDown: ArrowDownward,
    arrowUp: ArrowUpward,
    back: KeyboardArrowLeft,
    calendar: DateRange,
    cancel: Clear,
    check: Check,
    checkOutline: CheckCircleOutline,
    clear: Cancel,
    close: Close,
    cloud: Cloud,
    cloudDownload: CloudDownload,
    cloudUpload: CloudUpload,
    create: Add,
    contacts: Contacts,
    "delete": Delete,
    descending: ArrowDropDown,
    description: Description,
    document: InsertDriveFile,
    documentOutlined: InsertDriveFileOutlined,
    download: GetApp,
    dropdown: ArrowDropDown,
    edit: Edit,
    email: Email,
    error: ErrorIcon,
    errorOutline: ErrorOutline,
    event: Event,
    expandLess: ExpandLess,
    expandMore: ExpandMore,
    eye: Visibility,
    eyeClosed: VisibilityOff,
    find: Search,
    folder: Folder,
    forward: KeyboardArrowRight,
    forwardOutlined: ForwardOutlined,
    group: Group,
    help: Help,
    http: Http,
    info: Info,
    infoOutline: InfoOutlined,
    language: Language,
    launch: Launch,
    link: Link,
    lock: Lock,
    menu: Menu,
    person: Person,
    personOutline: PersonOutline,
    phone: PhoneIphone,
    refresh: Refresh,
    remove: Remove,
    removeCircle: RemoveCircle,
    removeCircleOutline: RemoveCircleOutline,
    restorePage: RestorePage,
    save: Save,
    search: Search,
    send: Send,
    sendOutlined: SendOutlined,
    cancelScheduleSendOutlined: CancelScheduleSendOutlined,
    settings: Settings,
    share: Share,
    signer: Person,
    sms: Sms,
    thumbDownOutlined: ThumbDownOutlined,
    thumbUpOutlined: ThumbUpOutlined,
    user: AccountCircle,
    userAdd: PersonAdd,
    wait: HourglassEmpty,
    warning: Warning,
    warningOutline: ReportProblemOutlined,
    watchLaterOutlined: WatchLaterOutlined
  };

  if (typeof iconSet[name] === 'undefined') {
    console.warn("Icon with name ".concat(name, " does not exist"));
    return React.createElement(Help, props);
  }

  var Icon = iconSet[name];
  return React.createElement(StyledIcon, props, React.createElement(Icon, null));
};

export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(StyledIcon, "StyledIcon", "/home/vsts/work/1/s/src/components/icons/Icon.js");
  reactHotLoader.register(_default, "default", "/home/vsts/work/1/s/src/components/icons/Icon.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();